import React, { useState } from 'react';
import FormModal from '../../../../common/FormModal';

const AddCategoryModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({ name: '', description: '' }); // إعادة تعيين النموذج
  };

  const handleClose = () => {
    setFormData({ name: '', description: '' }); // إعادة تعيين النموذج عند الإغلاق
    onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={handleSubmit}
      title="إضافة تصنيف جديد"
      submitText="إضافة"
      cancelText="إلغاء"
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            اسم التصنيف
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="input-base"
            placeholder="أدخل اسم التصنيف"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            الوصف
          </label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            className="input-base min-h-[100px]"
            placeholder="أدخل وصف التصنيف"
          />
        </div>
      </div>
    </FormModal>
  );
};

export default AddCategoryModal;
